import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import React from 'react';
import { MasterViewPage } from './MasterPage';


export const AuthRefuse = () => {
    return <MasterViewPage>
        <Container sx={{ textAlign: 'center' }}>
            <Typography component='h1'>Impossible de se connecter</Typography>
            <Typography>Connexion au site impossible</Typography>
        </Container>
    </MasterViewPage>;
};
